import React, { useState, useEffect, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Select from "react-select"
import redirectURL from "../redirectURL"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaInfoCircle } from "react-icons/fa";
import "./datepicker.css"

const todayIST = () =>
  new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

const PmPlantCurrentStock = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [highlightedDates, setHighlightedDates] = useState([]);

  // Slider state for Trigger
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [triggerDate, setTriggerDate] = useState(() => todayIST());
  const [isTriggering, setIsTriggering] = useState(false);

  const [currentDate, setCurrentDate] = useState("");
  const [warehouse, setWarehouse] = useState(null);
  const [skuCode, setSkuCode] = useState(null);
  const [category, setCategory] = useState(null);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [skuOptions, setSkuOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);

  // URL Update Modal States
  const [showUrlUpdateModal, setShowUrlUpdateModal] = useState(false);
  const [newUrl, setNewUrl] = useState("");
  const [urlError, setUrlError] = useState("");

  // CustomHeader component
  const CustomHeader = (props) => {
    const tooltip = props?.column?.getColDef()?.headerTooltip || "";
    const [showMenu, setShowMenu] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);

    const onMenuClick = (event) => {
      props.showColumnMenu(event.currentTarget);
    };

    const onSortRequested = (order, event) => {
      props.setSort(order, event?.shiftKey);
    };

    const getSort = () => {
      return props.column.getSort();
    };

    const isSortable = props.column.getColDef().sortable;

    return (
      <div
        style={{ display: "flex", alignItems: "center", gap: 6, position: "relative" }}
        onMouseEnter={() => setShowMenu(true)}
        onMouseLeave={() => setShowMenu(false)}
      >
        <span
          style={{
            cursor: isSortable ? "pointer" : "default",
            userSelect: "none"
          }}
          onClick={isSortable ? () => {
            const currentSort = getSort();
            let newSort = 'asc';
            if (currentSort === 'asc') newSort = 'desc';
            else if (currentSort === 'desc') newSort = null;
            onSortRequested(newSort, null);
          } : undefined}
        >
          {props.displayName}
        </span>

        {isSortable && (
          <div style={{ display: "flex", flexDirection: "column", marginRight: 2 }}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 10,
                opacity: getSort() === 'asc' ? 1 : 0.3,
                lineHeight: "8px"
              }}
              onClick={() => onSortRequested('asc', null)}
            >
              ↑
            </span>
            <span
              style={{
                cursor: "pointer",
                fontSize: 10,
                opacity: getSort() === 'desc' ? 1 : 0.3,
                lineHeight: "8px"
              }}
              onClick={() => onSortRequested('desc', null)}
            >
              ↓
            </span>
          </div>
        )}

        <div
          style={{ position: "relative", display: "inline-block" }}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <FaInfoCircle style={{ fontSize: 18, opacity: 0.7 }} />

          {showTooltip && tooltip && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                color: "white",
                padding: "8px 12px",
                borderRadius: "4px",
                fontSize: "12px",
                whiteSpace: "nowrap",
                zIndex: 1000,
                marginTop: "5px",
              }}
            >
              {tooltip}
            </div>
          )}
        </div>

        {props.enableMenu && (
          <span
            onClick={onMenuClick}
            style={{
              marginLeft: "5px",
              cursor: "pointer",
              fontSize: 14,
              opacity: showMenu ? 1 : 0,
              transition: "opacity 0.2s ease",
            }}
          >
            ☰
          </span>
        )}
      </div>
    );
  };

  const columnDefs = [
    { headerName: "Warehouse ID", field: "warehouse_id" },
    { headerName: "Warehouse Name", field: "warehouse_name" },
    { headerName: "SKU Code", field: "sku_code" },
    { headerName: "Type", field: "type" },
    { headerName: "Category", field: "category" },
    { headerName: "SKU Name", field: "sku_name" },
    { headerName: "Sub Category", field: "sub_category" },
    { headerName: "Bad Bin", field: "bad_bin" },
    { headerName: "Old Version", field: "old_version" },
    { headerName: "QC Hold", field: "qc_hold" },
    { headerName: "Current Version", field: "current_version" },
    {
      headerName: "Date",
      valueGetter: params => params.data.date ? new Date(params.data.date).toLocaleDateString() : ""
    },
  ];

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  }

  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
  }

  const getPMData = async () => {
    try {
      const response = await redirectURL.post("inventory/getPMData", {});

      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const { date, warehouses, skus, categories, data } = response.data;

          const formattedDate = date ? new Date(date).toISOString().split('T')[0] : '';

          const warehouseOptions = warehouses.map(w => ({ value: w, label: w }));
          warehouseOptions.unshift({ label: "ALL", value: "" });

          const skuOptions = skus.map(sku => ({ value: sku, label: sku }));
          skuOptions.unshift({ label: "ALL", value: "" });

          const categoryOptions = categories.map(cat => ({ value: cat, label: cat }));
          categoryOptions.unshift({ label: "ALL", value: "" });

          setWarehouseOptions(warehouseOptions);
          setSkuOptions(skuOptions);
          setCategoryOptions(categoryOptions);
          setWarehouse(warehouseOptions[0]);
          setSkuCode(skuOptions[0]);
          setCategory(categoryOptions[0]);
          setRowData(data);
          setCurrentDate(formattedDate);
          await getHighlightedDates();

        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        }
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch data");
      setBasicType("error");
      setShow(true);
    }
  }

  const getHighlightedDates = async () => {
    try {
      const response = await redirectURL.post("inventory/getPMAvailableDates", {});
      if (response.status === 200 && response.data.dates) {
        const dates = response.data.dates.map(dateStr => {
          try {
            return new Date(dateStr);
          } catch (e) {
            return null;
          }
        }).filter(date => date !== null);
        setHighlightedDates(dates);
      }
    } catch (error) {
      console.error("Failed to fetch highlighted dates:", error);
    }
  }

  const getMainData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getPMData();
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  }

  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata);
  }

  const getPMSkuOption = async () => {
    try {
      const query = {};

      if (warehouse && warehouse.value) {
        query.warehouse = warehouse.value;
      }

      if (category && category.value) {
        query.category = category.value;
      }

      if (currentDate) {
        query.date = currentDate;
      }

      const response = await redirectURL.post("inventory/getPMSkuOption", query);

      if (response.status === 200) {
        const { data } = response.data;
        const skuOptions = data.map(sku => ({ label: sku, value: sku }));
        skuOptions.unshift({ label: "ALL", value: "" });
        setSkuOptions(skuOptions);
        setSkuCode(skuOptions[0]);
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch SKU data");
      setBasicType("error");
      setShow(true);
    }
  }

  const getPMWarehouseOptions = async () => {
    try {
      const query = {};

      if (currentDate) {
        query.date = currentDate;
      }

      if (category && category.value) {
        query.category = category.value;
      }

      const response = await redirectURL.post("inventory/getPMWarehouseOptions", query);

      if (response.status === 200) {
        const { warehouses } = response.data;
        const warehouseOptions = warehouses.map(w => ({ value: w, label: w }));
        warehouseOptions.unshift({ label: "ALL", value: "" });
        setWarehouseOptions(warehouseOptions);
        setWarehouse(warehouseOptions[0]);
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch warehouse data");
      setBasicType("error");
      setShow(true);
    }
  }

  const getPMCategoryOptions = async () => {
    try {
      const query = {};

      if (currentDate) {
        query.date = currentDate;
      }

      const response = await redirectURL.post("inventory/getPMCategoryOptions", query);

      if (response.status === 200) {
        const { categories } = response.data;
        const categoryOptions = categories.map(cat => ({ value: cat, label: cat }));
        categoryOptions.unshift({ label: "ALL", value: "" });
        setCategoryOptions(categoryOptions);
        setCategory(categoryOptions[0]);
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch category data");
      setBasicType("error");
      setShow(true);
    }
  }

  const getPMDataByFilter = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    const params = {
      date: currentDate,
    };

    if (warehouse && warehouse.value) {
      params.warehouse = warehouse.value;
    }

    if (skuCode && skuCode.value) {
      params.sku_code = skuCode.value;
    }

    if (category && category.value) {
      params.category = category.value;
    }

    try {
      const response = await redirectURL.post(
        "inventory/getPMDataByFilter",
        params
      );
      const data = response.data.data;
      setRowData(data);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Error Failed to get PM Plant Current Stock Data");
    }
  };

  const setFilters = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getPMDataByFilter();
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  }

  const resetFilters = async () => {
    setWarehouse(warehouseOptions[0]);
    setSkuCode(skuOptions[0]);
    setCategory(categoryOptions[0]);
    await getMainData();
  }

  useEffect(() => {
    getMainData();
  }, []);

  useEffect(() => {
    if (currentDate) {
      getPMWarehouseOptions();
      getPMCategoryOptions();
    }
  }, [currentDate]);

  useEffect(() => {
    if (currentDate && (warehouse || category)) {
      getPMSkuOption();
    }
  }, [warehouse, category, currentDate]);

  const closeAlert = () => {
    setShow(false);
  };

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    setTriggerDate(todayIST());
  };

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    setTriggerDate(todayIST());
  };

  const openTriggerSlider = () => {
    setSliderType(1);
    setSliderTitle("Trigger PM Plant Current Stock");
    setSliderCl("trigger-pm-slider");
    setOverlyBlock("show-m");
    setSliderOpen(true);
  };

  const openUrlUpdateModal = () => {
    setNewUrl("");
    setUrlError("");
    setShowUrlUpdateModal(true);
  };

  const onSaveTrigger = async (e) => {
    e.preventDefault();
    if (!triggerDate) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please select a date");
      return;
    }

    try {
      setIsTriggering(true);
      setLoadshow("show-m");
      setOverlayBlock("show-m");

      // No URL check - just trigger directly
      const response = await redirectURL.post(
        "inventory/onTriggerPMPlantCurrentStock",
        { trigger_date: triggerDate }
      );

      const res = response?.data?.pyResponse;

      if (res?.status === "Success") {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle(res.message);
        setSliderOpen(false);
        setOverlyBlock("show-n");
        setTriggerDate(todayIST());
        
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Trigger PM Plant Current Stock",
          status: res.status,
          path: window.location.pathname
        };
        triggerUserAction(userData);

        // Refresh the data after successful trigger
        await getMainData();
      } 
      else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle(res?.message || "Failed to trigger PM Plant Current Stock");
      }

    } catch (error) {
      console.error("Error triggering PM Plant Current Stock:", error);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("error");
      setBasicTitle(
        error?.response?.data?.message || "Failed to trigger PM Plant Current Stock. Please try again later."
      );
      
      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Trigger PM Plant Current Stock",
        status: "Failed",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    } finally {
      setIsTriggering(false);
    }
  };

  // URL Update Functions
  const handleUrlChange = (e) => {
    const url = e.target.value;
    setNewUrl(url);
    setUrlError("");
    
    if (url && !url.startsWith("https://docs.google.com/spreadsheets")) {
      setUrlError("URL must start with https://docs.google.com/spreadsheets");
    }
  };

  const handleUrlUpdate = async () => {
    if (!newUrl.trim()) {
      setUrlError("Please enter a URL");
      return;
    }

    // Accept valid Google Sheet URLs
    const validPatterns = [
      /^https:\/\/docs\.google\.com\/spreadsheets\/d\/[a-zA-Z0-9-_]+$/,
      /^https:\/\/docs\.google\.com\/spreadsheets\/d\/[a-zA-Z0-9-_]+\/$/,
      /^https:\/\/docs\.google\.com\/spreadsheets\/d\/[a-zA-Z0-9-_]+\/export\?format=xlsx$/,
      /^https:\/\/docs\.google\.com\/spreadsheets\/d\/[a-zA-Z0-9-_]+\/edit\?gid=[^#\/]+#gid=[^\/]+$/
    ];

    let isValid = false;
    for (let pattern of validPatterns) {
      if (pattern.test(newUrl.trim())) {
        isValid = true;
        break;
      }
    }

    if (!isValid) {
      setUrlError(
        "Invalid URL format. Please enter a valid Google Sheet URL."
      );
      return;
    }

    // Normalize URL to export format
    let finalUrl = newUrl.trim();

    if (/\/export\?format=xlsx$/.test(finalUrl)) {
      // do nothing
    }
    else if (/\/edit\?gid=[^#\/]+#gid=[^\/]+$/.test(finalUrl)) {
      finalUrl = finalUrl.replace(/\/edit\?gid=[^#\/]+#gid=[^\/]+$/, "");
      finalUrl = finalUrl.replace(/\/$/, "");
      finalUrl = finalUrl + "/export?format=xlsx";
    }
    else if (/^https:\/\/docs\.google\.com\/spreadsheets\/d\/[a-zA-Z0-9-_]+\/$/.test(finalUrl)) {
      finalUrl = finalUrl.replace(/\/$/, "");
      finalUrl = finalUrl + "/export?format=xlsx";
    }
    else if (/^https:\/\/docs\.google\.com\/spreadsheets\/d\/[a-zA-Z0-9-_]+$/.test(finalUrl)) {
      finalUrl = finalUrl + "/export?format=xlsx";
    }

    setLoadshow("show-m");
    setOverlayBlock("show-m");

    try {
      // Update the URL in the database
      const updateResponse = await redirectURL.post("/inventory/updatePmTriggerUrl", {
        url: finalUrl
      });

      if (updateResponse.data.status === "success") {
        setShowUrlUpdateModal(false);
        setNewUrl("");
        setUrlError("");
        
        // Show success message
        setShow(true);
        setBasicType("success");
        setBasicTitle("Google Sheet URL updated successfully!");
        
        // User Action Triggering
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Updated PM Trigger URL",
          status: "Success",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      } else {
        setShow(true);
        setBasicType("info");
        setBasicTitle(updateResponse.data.message || "Failed to update URL");
      }
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle(error.response?.data?.message || "Failed to update URL");
    } finally {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };

  const closeUrlUpdateModal = () => {
    setShowUrlUpdateModal(false);
    setNewUrl("");
    setUrlError("");
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          >
          </SweetAlert>
        </div>

        <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
          <form className="col-sm-12 p-0 mt-4 mb-4" style={{ display: "flex", alignItems: "center" }}>
            <div className="col-sm-12 row ">
              <div className="col-sm-2 mb-1" style={{ display: "flex", flexDirection: "column" }}>
                <label style={{ fontSize: "13px", fontWeight: "400" }}>
                  Date:
                </label>
                <DatePicker
                  selected={currentDate ? new Date(currentDate) : null}
                  onChange={(date) => setCurrentDate(date ? date.toISOString().split('T')[0] : '')}
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  highlightDates={highlightedDates}
                  placeholderText="Select Date"
                  style={{ 
                    padding: "7px", 
                    borderRadius: "5px", 
                    border: "1px solid #d9d9d9", 
                    width: "100%", 
                    marginBottom: "15px", 
                    cursor: "pointer" 
                  }}
                />
              </div>

              <div className="col-sm-2 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="warehouse" style={{ fontSize: '13px', fontWeight: '400' }}>
                  Warehouse:
                </label>
                <Select
                  id="warehouse"
                  value={warehouse}
                  onChange={setWarehouse}
                  options={warehouseOptions}
                  styles={selectStyles}
                />
              </div>

              <div className="col-sm-2 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="skuCode" style={{ fontSize: '13px', fontWeight: '400' }}>
                  SKU Code:
                </label>
                <Select
                  id="skuCode"
                  value={skuCode}
                  onChange={setSkuCode}
                  options={skuOptions}
                  styles={selectStyles}
                />
              </div>

              <div className="ml-4 mt-4" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "0px 10px" }}>
                <button
                  type="button"
                  onClick={setFilters}
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "none",
                    cursor: "pointer"
                  }}
                >
                  Apply
                </button>
                <button
                  onClick={resetFilters}
                  type="button"
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "1px solid #d9d9d9",
                    cursor: "pointer"
                  }}
                >
                  Reset
                </button>
              </div>

              <div className="mt-4 mb-" style={{ flex: 1, display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                <button
                  type="button"
                  onClick={openUrlUpdateModal}
                  style={{
                    backgroundColor: "#fff",
                    color: "#93385D",
                    borderRadius: "5px",
                    height: "36px",
                    padding: "0 20px",
                    border: "1px solid #93385D",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center"
                  }}
                >
                  Change Google Sheet URL
                </button>
                <button
                  type="button"
                  onClick={openTriggerSlider}
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    borderRadius: "5px",
                    height: "36px",
                    padding: "0 20px",
                    border: "none",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center"
                  }}
                >
                  Trigger PM Plant Current Stock
                </button>
              </div>
            </div>
          </form>

          <div className="col-sm-12 p-0 pl-2">
            <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                pagination={true}
                paginationPageSize={100}
                enableRangeSelection={true}
                gridOptions={{
                  suppressHorizontalScroll: false
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Slider for Trigger PM Plant Current Stock */}
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{ width: "25%" }}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
        </div>
        {sliderType === 1 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              padding: 5,
            }}
          >
            <form
              style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}
              onSubmit={onSaveTrigger}
            >
              <div className="mb-1" style={{ display: "flex", flexDirection: "column" }}>
                <label
                  htmlFor="triggerDate"
                  style={{ fontSize: "13px", fontWeight: "400", cursor: "pointer" }}
                >
                  Date:
                </label>
                <DatePicker
                  selected={triggerDate ? new Date(triggerDate) : null}
                  onChange={(date) => setTriggerDate(date ? date.toISOString().split('T')[0] : '')}
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  placeholderText="Select Date"
                  minDate={new Date("2025-09-01")}
                  style={{
                    padding: "7px",
                    borderRadius: "5px",
                    border: "1px solid #d9d9d9",
                    width: "100%",
                    marginBottom: "15px",
                    cursor: "pointer",
                  }}
                  required
                />
              </div>

              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button
                  className="btn"
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    fontSize: "0.8rem",
                  }}
                  type="submit"
                  disabled={isTriggering}
                >
                  {isTriggering ? "Processing..." : "Trigger PM Plant Current Stock"}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>

      {/* URL Update Modal */}
      {showUrlUpdateModal && (
        <div className="popup-overlay">
          <div className="popup-box" style={{ maxWidth: "500px" }}>
            <h3 style={{ color: "#93385D", marginBottom: "20px" }}>Update Google Sheet URL</h3>
            
            <div style={{ marginBottom: "20px" }}>
              <p style={{ fontSize: "14px", color: "#555", marginBottom: "15px" }}>
                Enter the new Google Sheet URL.
              </p>
              
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "500" }}>
                Google Sheet URL:
              </label>
              <input
                type="url"
                value={newUrl}
                onChange={handleUrlChange}
                placeholder="https://docs.google.com/spreadsheets/d/..."
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: urlError
                    ? "1px solid #ff4444"
                    : "1.5px solid #e0e0e0",
                  fontSize: "14px",
                  outline: "none",
                  transition: "border-color 0.2s",
                }}
                onFocus={e => {
                  e.target.style.border = urlError
                    ? "1px solid #ff4444"
                    : "1.5px solid #93385D";
                }}
                onBlur={e => {
                  e.target.style.border = urlError
                    ? "1px solid #ff4444"
                    : "1.5px solid #e0e0e0";
                }}
              />
              {urlError && (
                <p style={{ color: "#ff4444", fontSize: "12px", margin: "5px 0 0 0" }}>
                  {urlError}
                </p>
              )}
              <p style={{ fontSize: "12px", color: "#666", marginTop: "5px" }}>
                Accepted formats: Share URL, Edit URL, or Export URL
              </p>
            </div>

            <div className="popup-actions" style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
              <button
                onClick={closeUrlUpdateModal}
                className="no-btn"
                style={{
                  backgroundColor: "#fff",
                  color: "#93385D",
                  border: "1px solid #93385D",
                  padding: "8px 20px",
                  borderRadius: "5px",
                  cursor: "pointer"
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleUrlUpdate}
                className="yes-btn"
                style={{
                  backgroundColor: "#93385D",
                  color: "#fff",
                  border: "none",
                  padding: "8px 20px",
                  borderRadius: "5px",
                  cursor: "pointer"
                }}
              >
                Update URL
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
      <div
        className={"overly-block " + overlyBlock}
        onClick={hideOverlySlideBlock}
      ></div>
    </>
  );
};

const selectStyles = {
  control: (base) => ({
    ...base,
    padding: '1px',
    borderRadius: '5px',
    border: '1px solid #d9d9d9',
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: 'normal',
    color: '#333',
    fontSize: '12px'
  }),
  option: (base, state) => ({
    ...base,
    fontSize: '13px',
    fontWeight: state.isSelected ? 'normal' : 'normal',
  })
};

export default PmPlantCurrentStock;